<template>
  <div>
    <nav class="is-mobile">
      <div class="level-right">
        <a class="level-item">
          <BDropdown
            data-test="partner-dropdown"
            position="is-bottom-left"
          >
            <template #trigger>
              <BIcon
                class="flex-center"
                icon="ellipsis-vertical"
                pack="fas"
                size="is-small"
              />
            </template>
            <BDropdownItem
              v-if="ProfileRecord.STATUS_ADDED === partner.attributes.status"
              custom
            >
              <div class="notification">
                {{ $t('contact.labels.inviteProfileFirstPartner') }}
              </div>
            </BDropdownItem>
            <BDropdownItem
              data-test="impersonate-partner"
              @click="impersonate(partner, current_client)"
            >
              {{ $t('contact.actions.impersonate') }}
            </BDropdownItem>
            <BDropdownItem
              data-test="customer-resend-invitation-email"
              @click="is_resend_invitation_modal = true"
            >
              {{ $t('contact.actions.resendInvitationEmail') }}
            </BDropdownItem>
            <BDropdownItem
              data-test="partner-delete"
              @click="deletePartner"
            >
              {{ $t('contact.actions.deletePartner') }}
            </BDropdownItem>
          </BDropdown>
        </a>
      </div>
    </nav>
    <div>
      <PartnerForm
        action="edit"
        class="p-3"
        :company_prop="company"
        :partner_prop="partner"
        @updateCompany="updateCompany"
        @updatePartner="updatePartner"
      >
        <template #partner-form-header="{ submit, reset, isVisible }">
          <div
            v-if="is_read_only"
            class="text-gray-500 italic"
            style="margin: 0"
          >
            <FontAwesomeIcon
              class="text-gray-500"
              icon="triangle-exclamation"
            />
            {{ $t('partner.labels.notEditable') }}
          </div>
          <div
            v-if="isVisible"
            class="buttons"
          >
            <ButtonPrimary
              action="save"
              data-test="partner-form-save-edit"
              @onClick="submit"
            >
              {{ $t('button.actions.save_changes') }}
            </ButtonPrimary>
            <ButtonTertiary @onClick="reset" />
          </div>
        </template>
        <template #partner-form-footer="{ submit, reset, isVisible }">
          <div
            v-if="isVisible"
            class="buttons"
          >
            <ButtonPrimary
              action="save"
              @onClick="submit"
            >
              {{ $t('button.actions.save_changes') }}
            </ButtonPrimary>
            <ButtonTertiary @onClick="reset" />
          </div>
        </template>
      </PartnerForm>
    </div>
    <b-modal v-model="is_resend_invitation_modal">
      <Modal
        action="invitation"
        @actionPrimary="resendInvitationEmail"
      >
        <template #title>
          {{ $t('profile.labels.explainerSendEmail', { name: partner.attributes.name }) }}
        </template>
        <template #ButtonPrimary>
          {{ $t('contact.actions.resendInvitationEmail') }}
        </template>
      </Modal>
    </b-modal>
  </div>
</template>

<script>
import PartnerForm from '@/app/_employees/components/contacts/PartnerForm.vue';
import Modal from '@/app/shared_components/modals/TheModal.vue';
import { Employee, ProfileRecord } from '@/app/data/model_constants';
import { mapActions, mapGetters } from 'vuex';
import useProfileImpersonation from '@/app/util/impersonation';
import useGlobalConfirm from '@/composables/useGlobalConfirm';

export default {
  name: 'PartnerProfile',
  components: {
    PartnerForm,
    Modal,
  },
  props: {
    partner: { type: Object, required: true },
  },

  setup() {
    const { impersonate } = useProfileImpersonation();
    const { confirm } = useGlobalConfirm();
    return { impersonate, confirm };
  },

  data() {
    return {
      is_resend_invitation_modal: false,
      Employee,
      ProfileRecord,
    };
  },

  computed: {
    ...mapGetters(['companies', 'current_client', 'current_profile']),
    company() {
      return _.find(this.companies, ['id', this.partner.attributes.company_id]);
    },

    is_read_only() {
      const non_editable = [ProfileRecord.STATUS_ACTIVE, ProfileRecord.STATUS_BLOCKED];
      return _.includes(non_editable, this.partner.attributes.status);
    },
  },

  methods: {
    ...mapActions(['UPDATE_COMPANY', 'UPDATE_PARTNER', 'DELETE_PARTNER', 'SEND_EMAIL_INVITATION']),

    async updateCompany(company) {
      try {
        await this.UPDATE_COMPANY({ record: company });
        this.toast_update_succeeded(company.attributes.name);
      } catch (error) {
        this.toast_action_failed(error);
      }
    },

    async updatePartner(partner) {
      try {
        await this.UPDATE_PARTNER({ record: partner });
        this.toast_update_succeeded(partner.attributes.name);
      } catch (error) {
        this.toast_action_failed(error);
      }
    },

    async resendInvitationEmail() {
      try {
        await this.SEND_EMAIL_INVITATION({ profile: this.partner });
        this.toast_success(this.$t('profile.toasts.emailResendSuccessfully'));
        this.$emit('fetchCustomer', this.partner);
      } catch (error) {
        this.toast_action_failed(error);
      }
    },

    async deletePartner() {
      const confirmed = await this.confirm({
        destructive: true,
        object_name: this.partner.attributes.name,
      });
      if (!confirmed) return;

      try {
        this.partner.attributes.discarded_at = new Date();
        await this.DELETE_PARTNER({ record: this.partner });
        this.$emit('deleted', this.partner);
      } catch (error) {
        this.toast_action_failed(error);
      }
    },
  },
};
</script>
